import { render, staticRenderFns } from "./StartView.vue?vue&type=template&id=0dabb801&scoped=true&"
import script from "./StartView.vue?vue&type=script&lang=js&"
export * from "./StartView.vue?vue&type=script&lang=js&"
import style0 from "./StartView.vue?vue&type=style&index=0&id=0dabb801&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dabb801",
  null
  
)

export default component.exports